import { useContext, useRef } from 'react';
import Sentinel from '@/common/Sentinel/Sentinel';
import ModalContext from '~/context/srp/ModalContext';
import { StickySearchContext } from '~/context/srp/StickySearchProvider';

export default function StickyHeaderSentinel() {
  const { isSearchBarModalOpen } = useContext(ModalContext);
  const { setStickySearchBar } = useContext(StickySearchContext);

  const isModalOpenRef = useRef(isSearchBarModalOpen);
  isModalOpenRef.current = isSearchBarModalOpen;

  const handleIntersectionChange = (isIntersecting: boolean) => {
    if (isModalOpenRef.current) return;
    setStickySearchBar(!isIntersecting);
  };

  return (
    <Sentinel
      onIntersectionChange={handleIntersectionChange}
      testId="sticky-header-sentinel"
      className="sm:-mt-xl"
    />
  );
}
